import {Lang} from 'yougile-lang'
import {DataObjectId, Hub} from 'yougile-model'
import {Items} from '@api/model/items'
import {MessageBox} from '@components/message-box'
import {Sync} from '../../client/sync'

export const moveTemplateApply = async (
  taskId: DataObjectId,
  template: Hub
) => {
  const data = template.data.movementTemplate
  if (!data) {
    return
  }

  const box = Sync.getCurrentSandbox()
  const column = box.getHub(data.destinationColumnId)
  const board = box.getHub(data.destinationBoardId)
  const project = box.getHub(data.destinationProjectId)
  if (!column || !board || !project) {
    return
  }

  if (column.deleted && column.properties?.['del'] !== 'no') {
    MessageBox.warn(Lang.msg.cannotMoveTaskColumnDeleted)
    return
  }

  if (board.deleted && board.properties?.['del'] !== 'no') {
    MessageBox.warn(Lang.msg.cannotMoveTaskBoardDeleted)
    return
  }
  if (project.deleted && project.properties?.['del'] !== 'no') {
    MessageBox.warn(Lang.msg.cannotMoveTaskProjectDeleted)
    return
  }

  const task = box.get(taskId) as Hub
  if (!task) {
    return
  }

  if (!(await Items.beforeMoveByTemplate(taskId, data))) {
    return
  }

  task.data ??= {}

  task.data.movementTemplateId = template.id
  task.commit()
}
